import { ScheduleServiceProvider } from './context/ScheduleServiceContext';
import { ScheduleWrapper } from './components/ScheduleWrapper/ScheduleWrapper';

export const ScheduleService = () => {
    return (
        <ScheduleServiceProvider>
            <ScheduleWrapper />
        </ScheduleServiceProvider>
    );
};
